import $axios from '@/store/axios-instance.js';

export default {
    state: {
        softwareVersionTypeDictionaryList: null,
        currentSoftwareVersionTypeDictionary: null,
        softwareVersionTypeDictList: null,
    },
    mutations: {
        retrieveSoftwareVersionTypeDictionaryList(state, entityList) {
            state.softwareVersionTypeDictionaryList = entityList
        },
        retrieveSoftwareVersionTypeDictionary(state, entity) {
            state.currentSoftwareVersionTypeDictionary = entity
        },
        insertSoftwareVersionTypeDictionary(state, entity) {
            state.softwareVersionTypeDictionaryList.push(entity)
        },
        updateSoftwareVersionTypeDictionary(state, payload) {
            let entity = state.softwareVersionTypeDictionaryList.find(function (item) {
                return item.id === payload.id
            })

            Object.assign(entity, payload);
        },
        deleteSoftwareVersionTypeDictionary(state, entity) {
            let entityIndex = state.softwareVersionTypeDictionaryList.findIndex(function (item) {
                return item.id === entity
            })
            if (entityIndex > -1) {
                state.softwareVersionTypeDictionaryList.splice(entityIndex, 1)
            }
        },
        retrieveSoftwareVersionTypeDictList(state, entityList) {
            state.softwareVersionTypeDictList = entityList
        },
    },
    actions: {
        retrieveSoftwareVersionTypeDictionaryList(context/*, payload*/) {
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .get('softwareVersionTypes')
                        .then(response => {
                            context.commit('retrieveSoftwareVersionTypeDictionaryList', response.data)
                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (e) {
                    reject()
                }
            })
        },
        retrieveSoftwareVersionTypeDictionary(context, payload) {
            return new Promise((resolve, reject) => {
                if (!payload) {
                    context.commit('retrieveSoftwareVersionTypeDictionary', null)
                    resolve()
                } else {
                    try {
                        let softwareVersionTypeDictionary = context.getters.softwareVersionTypeDictionaryList.find(function (item) {
                            return item.id === payload
                        })
                        context.commit('retrieveSoftwareVersionTypeDictionary', softwareVersionTypeDictionary ?? null)
                        resolve()
                    } catch (error) {
                        console.log(error)
                        reject(error)
                    }
                }
            })
        },
        // insert,update
        setSoftwareVersionTypeDictionary(context, payload) {
            return new Promise((resolve, reject) => {
                if (!payload.isUpdate) { //insert
                    try {
                        $axios
                            .post('softwareVersionTypes', {
                                id: payload.id,
                                name: payload.name,
                            })
                            .then(() => {
                                context.commit('insertSoftwareVersionTypeDictionary', payload)
                                resolve(payload)
                            })
                            .catch(error => {
                                console.log(error)
                                reject(error)
                            })
                    } catch (error) {
                        console.log(error)
                        reject(error)
                    }
                } else { //update
                    try {
                        $axios
                            .put('softwareVersionTypes', {
                                id: payload.id,
                                name: payload.name,
                            })
                            .then(() => {
                                context.commit('updateSoftwareVersionTypeDictionary', payload)
                                resolve(payload)
                            })
                            .catch(error => {
                                console.log(error)
                                reject(error)
                            })
                    } catch (error) {
                        console.log(error)
                        reject(error)
                    }
                }
            })
        },
        // delete
        deleteSoftwareVersionTypeDictionary(context, payload) {
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .delete('softwareVersionTypes/' + payload)
                        .then(() => {
                            context.commit('deleteSoftwareVersionTypeDictionary', payload)
                            resolve()
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (error) {
                    console.log(error)
                    reject(error)
                }
            })
        },
        retrieveSoftwareVersionTypeDictList(context/*, payload*/) {
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .get('softwareVersionTypes/dictList')
                        .then(response => {
                            context.commit('retrieveSoftwareVersionTypeDictList', response.data)
                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (e) {
                    reject()
                }
            })
        },
    },
    getters: {
        softwareVersionTypeDictionaryList(state) {
            return state.softwareVersionTypeDictionaryList ? state.softwareVersionTypeDictionaryList : []
        },
        currentSoftwareVersionTypeDictionary(state) {
            return state.currentSoftwareVersionTypeDictionary
        },
        softwareVersionTypeDictList(state) {
            return state.softwareVersionTypeDictList ? state.softwareVersionTypeDictList : []
        },
    }
}